import { EventInterceptionPlugin, FlagOverridePlugin } from '@launchdarkly/toolbar/plugins';
import type { LDPlugin } from 'launchdarkly-js-client-sdk';

let flagOverridePlugin: FlagOverridePlugin | undefined;
let eventInterceptionPlugin: EventInterceptionPlugin | undefined;

export const getFlagOverridePlugin = (): FlagOverridePlugin => {
    flagOverridePlugin ??= new FlagOverridePlugin();

    return flagOverridePlugin;
};

export const getEventInterceptionPlugin = (): EventInterceptionPlugin => {
    eventInterceptionPlugin ??= new EventInterceptionPlugin();

    return eventInterceptionPlugin;
};

// Lazy, not eager at module load. Still runs once per session wherever LD is configured, since
// the SDK needs plugins at initialize() time — only rendering the toolbar is flag-gated.
export const getDevToolbarLDPlugins = (): LDPlugin[] => [getFlagOverridePlugin(), getEventInterceptionPlugin()];
